window.clickedStimuliRTs = [];

function markClickedSingleStim(stim) {
	clearClickedStims();
	markStimClicked(stim);

	function markStimClicked(stim) {
        if(columnForTrial("button1", trialRow) != "na"){
            $("#button1").show();
        }
        $(stim).addClass('clicked');
        $(stim).css("background-color", "");
	}

	function clearClickedStims() {
        for(var i = 1; i <= window.stimFieldsMax; i++){
            if($(stimContainers[i]).hasClass('clicked')){
                $(stimContainers[i]).removeClass('clicked');
                if(isLongWordTrial(window.trialRow)){
                    $(stimContainers[i]).css("background-color", "#f0f0f0");
                }
            }
        }
	}
}


function markClickedMultipleStims(stim) {
    const trialOptions = window.listTrialResponseOptions[trialRow].multipleClicks;
    var clickedStimuli = $('.clicked').length;

    //all clicked stims are gonna have id imageX we want to get X
    var stimId = stim.id;
    var indexMatches = stimId.match(/\d+$/);
    var stimIndex = 1;
    if(indexMatches){
        stimIndex = parseInt(indexMatches[0], 10);
    }

	if($(stim).hasClass('clicked')){
        if(window.clickedStimuliRTs.length > 0){
            window.clickedStimuliRTs.shift();
        }
        $(stim).removeClass('clicked');
        if(isLongWordTrial(window.trialRow)){
            $(stim).css("background-color", "#f0f0f0");
        }
        clickedStimuli--;
        //remove image from list if it exists
        var listIndex = window.clickedImages.indexOf(stimIndex);
        if(listIndex > -1){
            window.clickedImages.splice(listIndex, 1);
        }
	}
	else{
        if(trialOptions.max && clickedStimuli >= trialOptions.max){
            return;
        }
        window.clickedStimuliRTs.push(Math.round(performance.now() - timeInMs));
        window.clickedImages.push(stimIndex);
        $(stim).addClass('clicked');
        $(stim).css("background-color", "");
        clickedStimuli++;
    }

    if(clickedStimuli >= trialOptions.max){
        saveMultipleClicks();
    }
    else if(trialOptions.min && clickedStimuli < trialOptions.min){
        $("#submitMultipleClicks").hide();
    }
    else{
        $('#submitMultipleClicks').css('display','block');
    }
}

function saveMultipleClicks(){
    var clickResponses = window.clickedImages;
    var trialOptions = listTrialResponseOptions[trialRow].multipleClicks;

    if(trialOptions.min && clickResponses.length < trialOptions.min){
        return;
        //display error maybe
    }

    if(trialOptions.max && clickResponses.length > trialOptions.max){
        return;
        //display error maybe
    }

    response = clickResponses.join(';');
    window.RTkeys_trial = window.clickedStimuliRTs.join(';');
    window.saveTrial(response);
    window.clearTimeouts();
    clearMultipleClicksSelection(window.trialRow);
    window.endTrial();
}

function hasMultipleClicks(){
	return listTrialResponseOptions[window.trialRow] && listTrialResponseOptions[window.trialRow].multipleClicks
}

function clearMultipleClicksSelection(trialRow){
    $('#submitMultipleClicks').remove();
    for(var i = 1; i <= window.stimFieldsMax; i++){
        $(stimContainers[i]).off();
    }
}

function enableMultipleClicksSelection(trialRow) {
    var lastTop = "";
    var lastLeft = "";
    window.clickedImages = [];
    window.clickedStimuliRTs = [];
    let maxTop = 0;
    for(var i = 1; i <= listNoStim[trialRow] + listNoStimS2[trialRow]; i++){

        $(stimContainers[i]).off();

		$(stimContainers[i]).on("click", function(){
			markClickedMultipleStims(this);
		});
        lastTop = parseInt(stimContainers[i].style.top) + stimContainers[i].clientHeight;
        maxTop = lastTop > maxTop ? lastTop : maxTop;
        lastLeft = parseInt(stimContainers[i].style.left) + stimContainers[i].clientWidth;
    }

    maxTop = maxTop + 20;

    var longWordButtonStyle = 'style="display:none;display:block;margin-left:auto;margin-right:auto;font-size:180%;margin-top:' + maxTop + 'px;background:#007ac0;text-shadow:none;color:white;border:none;padding:0 15px;"';

    var normalSubmitControls = '<button id="submitMultipleClicks" class="btn btn-primary" type="button" style="display:none;font-size:180%;margin-left:auto;margin-right:auto;margin-top:' + maxTop + 'px;" onclick="saveMultipleClicks()">Confirm</button>';

    var submitControls = '<button id="submitMultipleClicks" class="" type="button"' + longWordButtonStyle + 'onclick="saveMultipleClicks()">&#x2192;</button>';

    if(isLongWordTrial(window.trialRow)){
        $('#displayScreen').append(submitControls);
        // $('#submitMultipleClicks').css("margin-left", (lastLeft - parseInt($('#submitMultipleClicks').css("width")) + "px"));
    }
    else{
        $('#displayScreen').append(normalSubmitControls);
    }

    if(!listTrialResponseOptions[trialRow].multipleClicks.min){
        $('#submitMultipleClicks').css('display','block');
    }
}

function enableClickSelection(trialRow){
    if(columnForTrial("button1", trialRow) != "na"){
        $("#button1").hide();
    }
    for(var i = 1; i <= listNoStim[trialRow] + listNoStimS2[trialRow]; i++){
		$(stimContainers[i]).on("click", function(){
			markClickedSingleStim(this);
        })
    }
}